import { warning } from '@jutro/logger';
import { getLanguageFromLocale } from './locale';
const FALLBACK_LOCALE = 'en-US';
const warnDifference = (requestedLocale, loadedLocale) => warning("date-fns: Requested locale ".concat(requestedLocale, " not found; Falling back to ").concat(loadedLocale.code, "."));
export const getDateLocale = locale => {
  let dateLocale;
  try {
    dateLocale = require("date-fns/locale/".concat(locale, "/index.js"));
  } catch (_unused) {
    try {
      const fallbackLanguageLocale = getLanguageFromLocale(locale);
      dateLocale = require("date-fns/locale/".concat(fallbackLanguageLocale, "/index.js"));
    } catch (_unused2) {
      dateLocale = require("date-fns/locale/".concat(FALLBACK_LOCALE, "/index.js"));
    }
    warnDifference(locale, dateLocale);
  }
  return dateLocale;
};